var _defs, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBannerRightStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a1cae6;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #668fac;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1920 586.24 1920 1080 657 1080 657 1022.69 851.99 1022.69 851.99 946.67 1035.15 946.67 1035.15 875.24 1203.55 875.24 1203.55 803.35 1399.55 803.35 1399.55 729.56 1582.72 729.56 1582.72 658.13 1751.12 658.13 1751.12 586.24 1920 586.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1920 586.24 1920 1080 795.11 1080 795.11 1022.69 990.09 1022.69 990.09 946.67 1173.26 946.67 1173.26 875.24 1341.66 875.24 1341.66 803.35 1537.66 803.35 1537.66 729.56 1720.83 729.56 1720.83 658.13 1889.23 658.13 1889.23 586.24 1920 586.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerRightStairs);
export default __webpack_public_path__ + "static/media/home-banner-right-stairs.a3ad867062620cef93223fa16684854d.svg";
export { ForwardRef as ReactComponent };